<div class="modal-backdrop" (click)="closeModal()">
  <div class="notify-broadcast-panel" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h3>{{ 'notifyBroadcast.title' | translate }}</h3>
        <p>{{ 'notifyBroadcast.subtitle' | translate }}</p>
      </div>
      <button type="button" class="ghost-btn compact" aria-label="Close" (click)="closeModal()">×</button>
    </header>

    <section class="modal-body">
      <!-- Destinatario -->
      <div class="field">
        <label>{{ 'notifyBroadcast.target' | translate }}</label>
        <div class="segmented">
          <button type="button" [class.active]="targetType === 'admin'"
                  (click)="targetType = 'admin'; onTargetTypeChange()">
            {{ 'notifyBroadcast.targets.admin' | translate }}
          </button>
          <button type="button" [class.active]="targetType === 'entity'"
                  (click)="targetType = 'entity'; onTargetTypeChange()">
            {{ 'notifyBroadcast.targets.entity' | translate }}
          </button>
          <button type="button" [class.active]="targetType === 'user'"
                  (click)="targetType = 'user'; onTargetTypeChange()">
            {{ 'notifyBroadcast.targets.user' | translate }}
          </button>
        </div>
      </div>

      <!-- Selettore publisher / utente (multiplo) -->
      <div class="field" *ngIf="targetType !== 'admin'">
        <label>
          {{ (targetType === 'entity' ? 'notifyBroadcast.selectPublisher' : 'notifyBroadcast.selectUser') | translate }}
        </label>

        <div class="chips" *ngIf="targetIds.length">
          <span class="selected-chip" *ngFor="let id of targetIds">
            <span>{{ labelFor(id) }}</span>
            <button type="button" (click)="removeTarget(id)">×</button>
          </span>
        </div>

        <input type="text" class="text-input" [(ngModel)]="search"
               [placeholder]="'notifyBroadcast.searchPlaceholder' | translate">

        <!-- Filtro per permesso specifico (solo utenti): tree-select → chip -->
        <div class="perm-filter" *ngIf="targetType === 'user'">
          <span class="perm-filter-label">{{ 'notifyBroadcast.permFilter.title' | translate }}</span>

          <div class="chips" *ngIf="selectedPerms.length">
            <span class="selected-chip" *ngFor="let p of selectedPerms">
              <span>{{ permChipLabel(p) }}</span>
              <button type="button" (click)="removePerm(p)">×</button>
            </span>
          </div>

          <div class="perm-tree">
            <button type="button" class="perm-tree-trigger" (click)="permTreeOpen = !permTreeOpen">
              <span>{{ 'notifyBroadcast.permFilter.add' | translate }}</span>
              <span class="caret" aria-hidden="true">{{ permTreeOpen ? '▲' : '▼' }}</span>
            </button>

            <div class="perm-tree-panel" *ngIf="permTreeOpen">
              <!-- Permesso globale -->
              <button type="button" class="perm-tree-item"
                      [class.selected]="isPermSelected('all')" (click)="togglePerm('all')">
                <span class="check" aria-hidden="true">{{ isPermSelected('all') ? '✓' : '' }}</span>
                {{ 'notifyBroadcast.permFilter.all' | translate }}
              </button>

              <ng-container *ngFor="let g of sortedPermGroups; trackBy: trackByPermValue">
                <!-- Area di primo livello: selezionabile (<area>.all) -->
                <button type="button" class="perm-tree-item"
                        [class.selected]="isPermSelected(g.value)" (click)="togglePerm(g.value)">
                  <span class="check" aria-hidden="true">{{ isPermSelected(g.value) ? '✓' : '' }}</span>
                  {{ 'notifyBroadcast.permAreas.' + g.area | translate }}
                </button>

                <!-- Sotto-permessi (secondo livello) -->
                <button type="button" class="perm-tree-item child"
                        *ngFor="let c of g.children; trackBy: trackByPermValue"
                        [class.selected]="isPermSelected(c.value)" (click)="togglePerm(c.value)">
                  <span class="check" aria-hidden="true">{{ isPermSelected(c.value) ? '✓' : '' }}</span>
                  {{ permLeafLabel(g.area, c.leaf) }}
                </button>
              </ng-container>
            </div>
          </div>
        </div>

        <p class="hint" *ngIf="loadingOptions">{{ 'notifyBroadcast.loading' | translate }}</p>

        <ul class="option-list" *ngIf="!loadingOptions && targetType === 'entity'">
          <li *ngFor="let p of filteredPublishers">
            <button type="button" [class.selected]="isSelected(p.ID)" (click)="toggleTarget(p.ID)">
              <span class="check" aria-hidden="true">{{ isSelected(p.ID) ? '✓' : '' }}</span>
              <span class="option-name">{{ p.Name }}</span>
              <span class="option-id">{{ p.ID }}</span>
            </button>
          </li>
          <li class="empty" *ngIf="!filteredPublishers.length">{{ 'notifyBroadcast.noResults' | translate }}</li>
        </ul>

        <ul class="option-list" *ngIf="!loadingOptions && targetType === 'user'">
          <li *ngFor="let u of filteredUsers">
            <button type="button" [class.selected]="isSelected(u.ID)" (click)="toggleTarget(u.ID)">
              <span class="check" aria-hidden="true">{{ isSelected(u.ID) ? '✓' : '' }}</span>
              <span class="option-name">{{ u.email }}</span>
              <span class="option-id">{{ u.entityName || u.dataAccessLevel }}</span>
            </button>
          </li>
          <li class="empty" *ngIf="!filteredUsers.length">{{ 'notifyBroadcast.noResults' | translate }}</li>
        </ul>
      </div>

      <!-- Tipo messaggio -->
      <div class="field">
        <label>{{ 'notifyBroadcast.messageType' | translate }}</label>
        <div class="segmented">
          <button type="button" *ngFor="let t of messageTypes"
                  [class.active]="messageType === t" [ngClass]="'type-' + t"
                  (click)="messageType = t">
            {{ 'notifyBroadcast.types.' + t | translate }}
          </button>
        </div>
      </div>

      <!-- Messaggio -->
      <div class="field">
        <label>{{ 'notifyBroadcast.message' | translate }}</label>
        <textarea class="text-input" rows="4" [(ngModel)]="message"
                  [placeholder]="'notifyBroadcast.messagePlaceholder' | translate"></textarea>
      </div>

      <!-- Email opzionale -->
      <label class="checkbox-row">
        <input type="checkbox" [(ngModel)]="sendEmail">
        <span>{{ 'notifyBroadcast.alsoEmail' | translate }}</span>
      </label>
    </section>

    <footer class="modal-footer">
      <button type="button" class="ghost-btn" (click)="closeModal()">
        {{ 'notifyBroadcast.cancel' | translate }}
      </button>
      <button type="button" class="primary-btn" [disabled]="!canSend" (click)="submit()">
        {{ (sending ? 'notifyBroadcast.sending' : 'notifyBroadcast.send') | translate }}
      </button>
    </footer>
  </div>
</div>
